import { useEffect, useState } from "react";
import { Card, Row, Col, Checkbox, Divider, Button, Typography } from "antd";

import { recordError } from "src/utils/logService";
import util from '../../../utils/functions/custom';
import { Messages, Notify } from '../../../services/custom/Messages';
import { openNotification } from '@seims/shared';
import EditParticipantsRoles from "./EditParticipantRoles";
import service from '../../../services/citizenscienceService';

export default function ParticipantsRoles({ data }) {
  let msg = "";
  const [conceptualisationStage, setConceptualisationStage] = useState([]);
  const [rolesPostProject, setRolesPostProject] = useState([]);
  const [rolesDuringProject, setRolesDuringProject] = useState([]);
  const [scientistRoles, setScientistRoles] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [checked, setChecked] = useState(true);
  const { Title } = Typography;

  useEffect(() => {
    loadProjectParticipantRoles();
  }, []);

  const loadProjectParticipantRoles = () => {
    if (!util.isEmpty(data)) {
      console.log(">>>>", data);
      setConceptualisationStage(data.rolesPreProject);
      setRolesDuringProject(data.rolesDuringProject);
      setRolesPostProject(data.rolesPostProject);
      setScientistRoles(data.contributionRecognition);
      setConceptualisationStage(data.rolesPreProject);
    }
  };

  const editParticipantRoles = () => {
    setShowModal(true);
  };

  const handleCancel = () => {  
    setShowModal(false);
  };

  const handleModalSubmit = async (values) => {
    try {
      data.rolesPreProject = values.rolesPreProject;
      data.rolesDuringProject = values.rolesDuringProject;
      data.rolesPostProject = values.rolesPostProject;
      data.contributionRecognition = values.contributionRecognition;
      let rolesPre = [];
      let rolesDuring = [];
      let rolesPost = [];
      let rolesRecognition = [];

      values.rolesPreProject.forEach((current) => {
        rolesPre.push(current.key);
      });

      values.rolesDuringProject.forEach((during) => {
        rolesDuring.push(during.key);
      });

      values.rolesPostProject.forEach((post) => {
        rolesPost.push(post.key);
      });

      values.contributionRecognition.forEach((post) => {
        rolesRecognition.push(post.key);
      });

      data.projectProfile.rolesPreProject = rolesPre;
      data.projectProfile.rolesDuringProject = rolesDuring;
      data.projectProfile.rolesPostProject = rolesPost;
      data.projectProfile.contributionRecognition = rolesRecognition;
      data.projectProfile.otherDuringRole = values.otherDuringRole;
      data.projectProfile.otherPostRole = values.otherPostRole;
      // data.projectProfile.otherRecognition = values.otherRecognition;
      let projectId = data.id;

      const request = await service.editProject(data.projectProfile, projectId);

      if (request?.status == 200 || request?.status == 201) {
        msg = util.parseMessage(
          Messages.ADD_SUCCESS,
          "Participant roles updated"
        );
        openNotification("Participant Roles", msg, Notify.SUCCESS);
      }

      setShowModal(false);
      loadProjectParticipantRoles();
    } catch (error) {
      msg = util.parseMessage(Messages.GET_FAILURE);
      openNotification("Project", msg, Notify.ERROR);
      recordError(error);
    }
  };

  return (
    <div className="">
      <Row>
        <Col xs={24}>
          <div className="public-portal-section">
            <h2> Citizen Science - {data.projectName}</h2>
          </div>
        </Col>
      </Row>
      <Col xs={24}>
        <h3 className="center-align">
          Project Status -{" "}
          <span style={{ color: data.statusColor }}>{data.status}</span>{" "}
        </h3>
      </Col>
      <Card bordered={false} headStyle={{ border: 0, textAlign: "center" }}>
        <Row>
          <Col xs={12}>
            {/* <h3 className="h3-text">Participant Roles</h3> */}
          </Col>
          {data.status !== "Rejected" && data.status !== "Closed" && (
            <Col xs={12}>
              <Button
                className="right-align-button edit-button"
                type="primary"
                shape="round"
                onClick={() => editParticipantRoles()}
              >
                Edit
              </Button>
            </Col>
          )}
        </Row>
        <br></br>

        <Card title={<Title level={5}>Planned Participant Roles</Title>}>
          <Row>
            <Col xs={24} md={24}>
              <h4>
                <b>Conceptualisation Stage</b>
              </h4>
            </Col>
          </Row>
          <Row>
            <Col xs={24} md={24}>
              {conceptualisationStage?.map((data) => (
                <Row>
                  <Checkbox
                    key={data.value}
                    value={data.key}
                    checked={checked}
                    disabled
                  >
                    {data.value}
                  </Checkbox>
                </Row>
              ))}
              {/* {data.otherPostRole !== undefined && (
                <Row>
                  <Col xs={10} md={10}> Other role post:
                  </Col>
                  <Col xs={14} md={14}> {data.otherPostRole}
                  </Col>
                </Row>
              )} */}
            </Col>
          </Row>
          <br></br>
          <Row>
            <Col xs={24} md={24}>
              <h4>
                <b>Participant role during project</b>
              </h4>
            </Col>
          </Row>
          <Row>
            <Col xs={24} md={24}>
              {rolesDuringProject?.map((data) => (
                <Row>
                  <Checkbox
                    key={data.value}
                    value={data.key}
                    checked={checked}
                    disabled
                  >
                    {data.value}
                  </Checkbox>
                </Row>
              ))}

              {/* {data.otherDuringRole !== undefined && (
                <Row>
                  <Col xs={10} md={10}> Other role during:
                  </Col>
                  <Col xs={14} md={14}> {data.otherDuringRole}
                  </Col>
                </Row>
              )} */}
            </Col>
          </Row>
          <br></br>

          <Row>
            <Col xs={24} md={24}>
              <h4>
                <b>Participant role after project</b>
              </h4>
            </Col>
          </Row>
          <Row>
            <Col xs={24} md={24}>
              {rolesPostProject?.map((data) => (
                <Row>
                  <Checkbox
                    key={data.value}
                    value={data.key}
                    checked={checked}
                    disabled
                  >
                    {data.value}
                  </Checkbox>
                </Row>
              ))}
              {/* {data.otherPostRole !== undefined && (
                <Row>
                  <Col xs={10} md={10}> Other role post:
                  </Col>
                  <Col xs={14} md={14}> {data.otherPostRole}
                  </Col>
                </Row>
              )} */}
            </Col>
          </Row>
          <br />
          <Row>
            <Col xs={24} md={24}>
              <h4>
                <b>Citizen Scientist Contribution Recognition</b>
              </h4>
            </Col>
          </Row>
          <Row>
            <Col xs={24} md={24}>
              {scientistRoles?.map((data) => (
                <Row>
                  <Checkbox
                    key={data.value}
                    value={data.key}
                    checked={checked}
                    disabled
                  >
                    {data.value}
                  </Checkbox>
                </Row>
              ))}
            </Col>
          </Row>
        </Card>
      </Card>

      <Row>
        <Col xs={24}>
          <EditParticipantsRoles
            rolesData={data}
            visible={showModal}
            onCancel={handleCancel}
            onModalSubmit={handleModalSubmit}
          />
        </Col>
      </Row>
    </div>
  );
}
